import { useCallback, useEffect, useState } from 'react';

export const TABS = ['health', 'dcma', 'findings', 'evm'];
export const DEFAULT_TAB = 'health';
export const DISABLED_TABS = new Set(['evm']);

function readTabFromUrl() {
  if (typeof window === 'undefined') return DEFAULT_TAB;
  const params = new URLSearchParams(window.location.search);
  const tab = params.get('tab');
  return TABS.includes(tab) && !DISABLED_TABS.has(tab) ? tab : DEFAULT_TAB;
}

/**
 * Tab state synced to the URL `?tab=` query param. Back/forward navigation
 * preserves the tab. Disabled tabs (e.g. EVM in Phase A) fall back to the
 * default instead of being settable.
 */
export function useTabRouter() {
  const [tab, setTabState] = useState(readTabFromUrl);

  useEffect(() => {
    const onPop = () => setTabState(readTabFromUrl());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const setTab = useCallback((next) => {
    if (!TABS.includes(next) || DISABLED_TABS.has(next)) return;
    const params = new URLSearchParams(window.location.search);
    params.set('tab', next);
    const url = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
    window.history.pushState({}, '', url);
    setTabState(next);
  }, []);

  return [tab, setTab];
}
